import type { FC } from 'react';
import styles from '../styles/select.module.scss';

export type SelectOption = { value: string; label: string; disabled?: boolean };

const Select: FC<{
    className?: string;
    name: string;
    title: string;
    options: SelectOption[];
    selectedOption: string | null;
    onSelect: (value: string) => void;
}> = ({ className = '', name, title, options, selectedOption, onSelect }) => {
    return (
        <select
            className={`${styles.select} ${selectedOption === null ? styles.disabled : ''} ${className}`}
            name={name}
            value={selectedOption ?? ''}
            onChange={(e) => onSelect(e.target.value)}
        >
            <option value="" disabled>
                {title}
            </option>
            {options.map((option) => (
                <option key={option.value} value={option.value} disabled={option.disabled}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default Select;
